import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Pink_Btn from "../../../../common/common_btn/pink_btn/Pink_Btn";
import './Select_Language.css'
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AllLanguage } from "../../../../../features/admin/common/Slice";
import Cookies from "js-cookie";

const Select_Language = () => {
  const langs = ["Gujarati", "Hindi", "English"];
  const [selectedValue, setSelectedValue] = useState("");

  const dispatch = useDispatch();
  const languages = useSelector((state) => state.common.languages);


  useEffect(() => {
    dispatch(AllLanguage());
  }, [dispatch]);

  const navigate = useNavigate();
  useEffect(() => {
    const savedLang = Cookies.get("language_id");
    if (savedLang) {
      setSelectedValue(Number(savedLang));
    }
  }, []);


  return (
    <section className="Select_Language Personalization">
      <div className="row justify-content-center">
        <div className="col-lg-12 col-md-10">
          <div className="top_small_banner">
            <img
              src="/assets/images/profile/settings/banners/language_banner.png"
              className="banner_img"
            />
          </div>
        </div>
        <div className="col-lg-12 col-md-10">
          <div className="select_lang_div">
            <p className="title_text">Select Language</p>

            <div className="langs_holder">
              {languages?.map((item) => {
                return (
                  <div
                    key={item?.id}
                    className={`lang_div ${selectedValue === item?.id ? "active" : ""}`}
                    onClick={() => setSelectedValue(Number(item?.id))}
                  >
                    <p className="lang_text">{item?.name}</p>
                    <div className="radio_holder">
                      <Form.Check
                        type="radio"
                        name="lang"
                        value={Number(item?.id)}
                        checked={selectedValue === Number(item?.id)}
                        onChange={(e) => setSelectedValue(Number(e.target.value))}
                      />
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="btn_holder">
              <Pink_Btn
                btnText={"OK"}
                onClick={() => {
                  if (!selectedValue) return;

                  Cookies.set("language_id", selectedValue, {
                    expires: 365,   // 1 year
                  });

                  navigate("/settings/menu");
                }}
              />

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Select_Language;
